module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "sidebar-menu",
    staticStyle: {
      "margin-top": "26px",
      "margin-left": "9px"
    },
    attrs: {
      "data-widget": "tree"
    }
  }, [(this.key != 'reportManager' && this.key != 'monitoringManager') ? _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("Management")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/primarytrip",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/primaryTrip.png"),
      "alt": "primaryTrip.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Primary Trips ")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/surveys",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/surveryIcon.png"),
      "alt": "surveryIcon.png"
    }
  }), _c('span', {
    staticClass: "page"
  }, [_vm._v("Surveys")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/houses",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/houseIcon.png"),
      "alt": "houseIcon.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Houses")])])])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("Monitoring")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/route-tracking",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/vehicleMonitoringIcon.png"),
      "alt": "vehicleMonitoringIcon.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Route Tracking")])])])], 1), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('li', {
    staticClass: "header"
  }, [_vm._v("Reports")]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/line_collection_reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('svg', {
    attrs: {
      "width": "26px",
      "height": "26px",
      "viewBox": "0 0 512 512",
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink"
    }
  }, [_c('title', [_vm._v("report-text")]), _vm._v(" "), _c('g', {
    attrs: {
      "id": "Page-1",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    }
  }, [_c('g', {
    attrs: {
      "id": "add",
      "fill": "#337ab7",
      "transform": "translate(42.666667, 85.333333)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M341.333333,1.42108547e-14 L426.666667,85.3333333 L426.666667,341.333333 L3.55271368e-14,341.333333 L3.55271368e-14,1.42108547e-14 L341.333333,1.42108547e-14 Z M330.666667,42.6666667 L42.6666667,42.6666667 L42.6666667,298.666667 L384,298.666667 L384,96 L330.666667,42.6666667 Z M149.333333,234.666667 L149.333333,266.666667 L85.3333333,266.666667 L85.3333333,234.666667 L149.333333,234.666667 Z M341.333333,234.666667 L341.333333,266.666667 L192,266.666667 L192,234.666667 L341.333333,234.666667 Z M149.333333,170.666667 L149.333333,202.666667 L85.3333333,202.666667 L85.3333333,170.666667 L149.333333,170.666667 Z M341.333333,170.666667 L341.333333,202.666667 L192,202.666667 L192,170.666667 L341.333333,170.666667 Z M149.333333,106.666667 L149.333333,138.666667 L85.3333333,138.666667 L85.3333333,106.666667 L149.333333,106.666667 Z M341.333333,106.666667 L341.333333,138.666667 L192,138.666667 L192,106.666667 L341.333333,106.666667 Z",
      "id": "Combined-Shape"
    }
  })])])]), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Line Collection")])])]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/city_collection_reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('svg', {
    attrs: {
      "fill": "#FF0000",
      "width": "26px",
      "height": "26px",
      "viewBox": "0 0 24 24",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M13,9a1,1,0,0,0-1-1H3A1,1,0,0,0,2,9V22H13ZM6,20H4V18H6Zm0-4H4V14H6Zm0-4H4V10H6Zm5,8H8V18h3Zm0-4H8V14h3Zm0-4H8V10h3Zm3.5-6H6V3A1,1,0,0,1,7,2H17a1,1,0,0,1,1,1v7H15V6.5A.5.5,0,0,0,14.5,6ZM22,13v9H19.5V18h-2v4H15V13a1,1,0,0,1,1-1h5A1,1,0,0,1,22,13Z"
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("City Collection")])])]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/monthly_city_collection_reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    attrs: {
      "src": "/static/img/monthlyReport.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Monthly City Collection")])])]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/ward-reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/wardReport.png"),
      "alt": "wardReport.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Ward Collection")])])]) : _vm._e(), _vm._v(" "), (_vm.key != 'monitoringManager') ? _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/trip-reports",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/vehicleReport.png"),
      "alt": "vehicleReport.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Vehicle Trip")])])]) : _vm._e(), _vm._v(" "), (
    this.key != 'superVisor' &&
    this.key != 'reportManager' &&
    _vm.key != 'monitoringManager'
  ) ? _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('li', {
    staticClass: "header"
  }, [_vm._v("Setup")]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/city",
      "active-class": "active"
    }
  }, [(this.checkRole == 'Super Admin') ? _c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/cityMaster.png"),
      "alt": "cityMaster.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("City")])]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: (['user', 'createUser']),
      expression: "['user', 'createUser']",
      modifiers: {
        "if": true
      }
    }],
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/users",
      "active-class": "active"
    }
  }, [(this.checkRole == 'Super Admin') ? _c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/userIcon.png"),
      "alt": "userIcon.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("User")])]) : _vm._e()]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/helperAndDriver",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/staffMaster.png"),
      "alt": "staffMaster.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Staff")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/wasteCollectionArea",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/zoneMaster.png"),
      "alt": "zoneMaster.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Zone")])])]), _vm._v(" "), _c('router-link', {
    staticClass: "pageLink",
    attrs: {
      "tag": "li",
      "to": "/vehicles",
      "active-class": "active"
    }
  }, [_c('a', [_c('img', {
    attrs: {
      "src": require("../../../../static/img/sidebarIcon/vehicleMaster.png"),
      "alt": "vehicleMaster.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "page"
  }, [_vm._v("Vehicle")])])])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-84891178"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/main/SidebarMenu.vue
// module id = 2373
// module chunks = 1